// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9451ecb3","239":"9f8c1cc9","455":"5dd92339"}[chunkId] + ".chunk.js";
};